// Auto-generated by scripts/prefetch-marketing-pages.mjs — DO NOT EDIT
// Generated at: 2026-09-04T12:29:58.527Z
import { Routes } from '@angular/router';

export const MARKETING_PAGE_SLUGS = ["athletes","beauty-fashion","creators-home","entertainers-performers","film-tv-microdramas","food-nutrition","gamers-streamers","health-wellness-fitness","home","membership-organizations","music-artists","podcasters-journalists-authors","politics-movements","sports-teams-NIL"] as const;

export const MARKETING_PAGE_ROUTES: Routes = [
  {
    path: 'athletes',
    loadChildren: () =>
      import('../modules/marketing-page/marketing-page.module').then(
        (m) => m.MarketingPageModule
      ),
    data: { marketingSlug: 'athletes' }
  },
  {
    path: 'beauty-fashion',
    loadChildren: () =>
      import('../modules/marketing-page/marketing-page.module').then(
        (m) => m.MarketingPageModule
      ),
    data: { marketingSlug: 'beauty-fashion' }
  },
  {
    path: 'creators-home',
    loadChildren: () =>
      import('../modules/marketing-page/marketing-page.module').then(
        (m) => m.MarketingPageModule
      ),
    data: { marketingSlug: 'creators-home' }
  },
  {
    path: 'entertainers-performers',
    loadChildren: () =>
      import('../modules/marketing-page/marketing-page.module').then(
        (m) => m.MarketingPageModule
      ),
    data: { marketingSlug: 'entertainers-performers' }
  },
  {
    path: 'film-tv-microdramas',
    loadChildren: () =>
      import('../modules/marketing-page/marketing-page.module').then(
        (m) => m.MarketingPageModule
      ),
    data: { marketingSlug: 'film-tv-microdramas' }
  },
  {
    path: 'food-nutrition',
    loadChildren: () =>
      import('../modules/marketing-page/marketing-page.module').then(
        (m) => m.MarketingPageModule
      ),
    data: { marketingSlug: 'food-nutrition' }
  },
  {
    path: 'gamers-streamers',
    loadChildren: () =>
      import('../modules/marketing-page/marketing-page.module').then(
        (m) => m.MarketingPageModule
      ),
    data: { marketingSlug: 'gamers-streamers' }
  },
  {
    path: 'health-wellness-fitness',
    loadChildren: () =>
      import('../modules/marketing-page/marketing-page.module').then(
        (m) => m.MarketingPageModule
      ),
    data: { marketingSlug: 'health-wellness-fitness' }
  },
  {
    path: 'home',
    loadChildren: () =>
      import('../modules/marketing-page/marketing-page.module').then(
        (m) => m.MarketingPageModule
      ),
    data: { marketingSlug: 'home' }
  },
  {
    path: 'membership-organizations',
    loadChildren: () =>
      import('../modules/marketing-page/marketing-page.module').then(
        (m) => m.MarketingPageModule
      ),
    data: { marketingSlug: 'membership-organizations' }
  },
  {
    path: 'music-artists',
    loadChildren: () =>
      import('../modules/marketing-page/marketing-page.module').then(
        (m) => m.MarketingPageModule
      ),
    data: { marketingSlug: 'music-artists' }
  },
  {
    path: 'podcasters-journalists-authors',
    loadChildren: () =>
      import('../modules/marketing-page/marketing-page.module').then(
        (m) => m.MarketingPageModule
      ),
    data: { marketingSlug: 'podcasters-journalists-authors' }
  },
  {
    path: 'politics-movements',
    loadChildren: () =>
      import('../modules/marketing-page/marketing-page.module').then(
        (m) => m.MarketingPageModule
      ),
    data: { marketingSlug: 'politics-movements' }
  },
  {
    path: 'sports-teams-NIL',
    loadChildren: () =>
      import('../modules/marketing-page/marketing-page.module').then(
        (m) => m.MarketingPageModule
      ),
    data: { marketingSlug: 'sports-teams-NIL' }
  }
];
